import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
 import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import TripShipment from './../TripShipment';
import closeTrip from './../closeTrip';
import depsStartTrip from './../depsStartTrip';
import TripServices from './../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from './../../../../../shared/constants/constant';
import TripSheetPdf from '../../TripSheetPdf'
import FTCMemoDepositSlip from './../../../FtcRadShipment/FTCMemoDepositSlip'
import Printd from 'printd';
import iptracker from '../../../../../../views/components/commonfunction/iptracker';

export default {
  name: 'createTripManagement',
  components: {
    Printd,
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    depsStartTrip,
    closeTrip,
    TripShipment,
    VueElementLoading,
    TripServices,
    CONSTANT,
    TripSheetPdf,
    FTCMemoDepositSlip,
    iptracker
  },
  props: ['parentOBJ'],
  data() {
    return {
      tripsheetdata:'',
      showtripsheetpdf:false,
      showTripShipment:false,
      accordianTab:{1:false, 2:false, 3:false},
      selectedAWB: [],
      isAllAddedSelected:'',
      selectedRemoveAWB: [],
      expanded:false,
      showDepartTrip:false,
      closeTrip:false,
      Scandocument: '',
      offset: 0,
      totalCount: 0,
      ScanAWB: '',
      shipmentType: '',
      vehicleODOReading: '',
      showTripSheet: false,
      Loader: false,
      loader:false,
      showGenerateTrip: false,
      tableColumn: [],
      innerTableColumn: ['Assigned'],
      firstmileAWBItem: [],
      LastmileAWBItem: [],
      tableColumn1: [],
      innerTableColumn1: ['Assigned'],
      tableItems:[],
      tableItems1: [],
      defaultTab: 'firstmile',
      isAWBLoading: false,
      lastmileMPSItem: [],
      clientData: [],
      AWBScanned: 0,
      MPSScanned: 0,
      startTripObj: this.parentOBJ,
      ODOErr:'',
      AWBLengthLimit:CONSTANT.AWB_LENGTH_LIMIT,
      MPSLengthLimit:CONSTANT.MPS_LENGTH_LIMIT,
      tripStatus: this.parentOBJ.tripstatus,
      scannedAWBArr: [],
      defaultscanflag: '', //1 for awb and 2 for mps
      scantype:'',
      tobescanned:'',
      printAwbs:[],
      isMultiPrint:true,
      ODOhidden:false,
      isdth: 0,
      destinationhubname:  this.parentOBJ.hubname,
      userdetail : {},
      temparr:[],
      modalData:'',
      showMPS:false 
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userdetail = userdetail;
    let client = await TripServices.getActiveInactiveClientList();
    this.clientData = client.data.data
    // this.getTripAWB()
  },
  methods: {

    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-blue']
      } else {
        return ['bg-light', 'text-info']
      }
    },


    changeTab(data){
      if(data == 'firstmile'){
        this.defaultTab = 'firstmile'
      } else{
        this.defaultTab = 'lastmile'
      }
      this.getTripAWB()
    },

    clearData(){
      this.Scandocument = ''
      this.ScanAWB = '';
      if(this.defaultTab == 'firstmile') {
        this.firstmileAWBItem = []
      } else {
        this.LastmileAWBItem = []
      }
      this.AWBScanned = 0
    },
    refreshData(){
      this.Scandocument = ''
      this.ScanAWB = ''
      this.isLoading = true
    },
    async getTripAWB(){
      this.isAWBLoading = true
      let input = {
        tripid: this.parentOBJ.tripID,
        type: this.defaultTab
      }
      this.AWBScanned = 0
      let result = await TripServices.getTripAWB(input);
      if(result.data.code == 200){
        this.scantype = result.data.data.hubsetting.scantype
        if(this.scantype == "AWB"){
          this.defaultscanflag = 1
          this.shipmentType = 1
        }
        else{
          this.defaultscanflag = 2
          this.shipmentType = 2
        }
        this.clearData()
        result.data.data.result.map(obj => {
          if(obj.documentscanned){
            this.AWBScanned += 1
          }
        })
        // this.AWBScanned = this.scannedAWBArr.length
        console.log(this.AWBScanned);
        if(this.defaultTab == 'firstmile'){
          this.firstmileAWBItem = result.data.data.result
        }else{
          this.LastmileAWBItem = result.data.data.result
          this.getTripMPS()
          this.getFTCAwb()
        }
      }
      this.isAWBLoading = false
    },
    selectAllAdded() {
      if (this.isAllAddedSelected) {
        this.selectedAWB.forEach(item => {
          if (this.selectedRemoveAWB.some(el => el.AWB == item.AWB)) {
            return
          } else {
            this.selectedRemoveAWB.push(item)
          }
        })
      }
      else {
        this.selectedRemoveAWB = this.selectedRemoveAWB.filter(item => {
          if (this.selectedAWB.some(el => el.AWB == item.AWB)) {
            return false
          } else {
            return true
          }
        })
      }
    },
    selectRemove() {
      if (this.isAllAddedSelected) {
        this.isAllAddedSelected = 0
      }
    },
    async getFTCAwb(){
      this.isAWBLoading = true
      let input = {
        tripid: this.parentOBJ.tripID,
        type: this.defaultTab
      }
      let result = await TripServices.getFTCAwb(input);
      if(result.data.code == 200){
        this.selectedAWB = result.data.data.rows.map((el)=>{
          return {
            'AWB':el.awb
          }
        })
      }
      this.isAWBLoading = false
    },
    async GetCashMemoData(awb){
      let payload = {
        'awb':awb
      }
      let data = await TripServices.GetCashMemoData(payload)
      return data
    },
    async setMulipleAwbData(){
      this.printAwbs=[]
      this.isMultiPrint=false
      for(const item of this.selectedRemoveAWB){
        let data = await this.GetCashMemoData(item.AWB)
        if(data.data.code == 200){
        this.printAwbs.push(data.data.data)
        this.printAwbs.push(data.data.data)
        }else{
          this.$alert(item.AWB + " - " + data.data.message,"", "error");
        }
        this.isMultiPrint=true
      }
    },

    async PrintCashMemo(){
      if(this.selectedRemoveAWB.length>10){
        this.$alert("Please Select less than 10 AWB for print","", "error");
        return
      }
      this.isLoading=true
      try {
        await this.setMulipleAwbData();
        if (this.printAwbs.length < 1) {
          this.isLoading = false
          return
        }
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
                margin-top: 1rem;
                margin-bottom: 1rem;
                border: 1;
                border-top: 1px solid #000;
            }
           table {
               border-collapse: collapse;
               margin-left:3px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printCashMemoData'), cssText);
          })
    } catch (error) {
      this.isLoading=false
      }
    },

    async getTripMPS(){
      this.lastmileMPSItem = []
      this.temparr = []
      this.MPSScanned = 0
      this.isAWBLoading = true
      let input = {
        tripid: this.parentOBJ.tripID,
        type: this.defaultTab
      }
      let result = await TripServices.getTripMPS(input);
      if(result.data.code == 200){
        this.lastmileMPSItem = result.data.data.result
        this.tobescanned = result.data.data.count
        this.lastmileMPSItem = this.lastmileMPSItem.map(obj => {
          if(obj.mpsscanned == 1){
            this.MPSScanned = this.MPSScanned + 1
          }
          obj.clientname = ''
          this.clientData.map(item => {
            if(obj.clientid == item.ClientMasterID){
              obj.clientname = item.ClientShortName
            }
          })
          return obj
        })
      }
      for(let i =0;i<100;i++){
        if(this.lastmileMPSItem.length>100){
          this.temparr.push(this.lastmileMPSItem[i])
        }
        else{
          this.temparr = this.lastmileMPSItem
        }
      }
      this.isAWBLoading = false
    },

    openDeps(){
      this.closeTrip = true;
    },
    expandAll(){
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll(){
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid){
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },
    showCreateTrip() {
      this.$emit("goBackToParent")
    },
    async getTripSheetDetails(payload){
      let result = await TripServices.GetTripSheetDetails(payload)
      return result;
         },
    async PrintTripSheet() {
      this.showGenerateTrip = true;
      this.showTripShipment=true
    },
    downloadPDF() {
      const d = new Printd();
      let cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:4px;
            }
            .vas{
              display:flex;
              flex-direction: column;
              border-bottom:none;
              border-left:none;
              border-right:none;
              padding-top:10px;
             }
             .apptDate{
               border: 1px solid black;
               font-size: 12px;
               border-radius: 10px;
               font-weight: bold;
               padding: 5px 1px;
               margin-bottom:10px;
             }
             .mall{
              border: 1px solid black;
              font-size: 12px;
              border-radius: 10px;
              font-weight: bold;
              padding: 5px 15px;
              margin-bottom:10px;
            }
            .style1{
             padding-bottom: 130px;
             padding-left:150px;
            }
            .style2{
             padding-left:180px;
            }
            .style7{
             width:40px;
            }
            .style3{
             padding-left:180px;
            }
            .style4{
             padding-left:-150px;
            }
            .style5{
             width: 8%;
            }
            .style6{
             width: 8%;
            }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:30px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          @media print {
            body {
           margin-left: 0mm; margin-right: 0mm}
}
          `
      d.print(document.getElementById('printPDFData'), cssText);
      },
   async ShowTripSheetPdf(){
     try {
      this.loader=true;
      this.showtripsheetpdf=false;
      let payload={
        tripid:this.parentOBJ.tripID
      }
      let data = await this.getTripSheetDetails(payload)
      this.tripsheetdata={
        LmPending:data.data.data.LmPending,
        BranchName:data.data.data.BranchName,
        BranchCode:data.data.data.BranchCode,
        vehicleType:data.data.data.vehicletype,
        vehicleNumber:data.data.data.vehiclenumber,
        vehicleVendorName:data.data.data.vehiclevendorname,
        vehicleVendorType:data.data.data.vehiclevendortype,
        pickups:data.data.data.pickups,
        deliveries:data.data.data.deliveries,
        totalMpsFm:data.data.data.totalMpsFm,
        totalMpsLm:data.data.data.totalMpsLm,
        totalAwbPick:data.data.data.totalAwbToPick,
        totalAwbDeliver:data.data.data.totalAwbToDeliver,
        tripstartdate:data.data.data.tripstartdate,
        username:data.data.data.username,
        userid:data.data.data.userid,
        tripid:data.data.data.tripid,
        barcodevalue:data.data.data.tripid,
        startkm:data.data.data.startkm,
        endkm:data.data.data.endkm,
        FmTotalPhysicalWt:data.data.data.FmTotalPhysicalWt,
        LmTotalPhysicalWt:data.data.data.LmTotalPhysicalWt,
        destinationhubname: this.destinationhubname,
      }
      this.showtripsheetpdf=true;
      this.$nextTick(() => {
        this.downloadPDF();
      })
      this.loader=false;
     } catch (error) {
       console.log(error);
      this.loader=false;
     }
    },
    closeTripSheetPdf(){
      this.showtripsheetpdf=false
    },
    generateTripSheet(){
       this.showGenerateTrip = true;
       this.showTripSheet = false;
    },
    openTripSheet(){
       this.showTripSheet = true;
    },
    closeGenerateTripSheet(){
       this.showGenerateTrip = false;
    },
    closeTripSheet(){
       this.showTripSheet = false;
    },
    async startTrip(){
	  try {
		if(this.parentOBJ.vehicleFlag == true){
			this.vehicleODOReading = this.vehicleODOReading != 0 ? this.vehicleODOReading : 0
			this.ODOhidden = true;
		}else{
		  if(!this.vehicleODOReading){
			this.ODOErr = 'Please enter ODO reading(km)'
			this.ODOhidden = false;
			return false
		  }
		}
		this.Loader = true
		let inputpayload = {
		  tripid: this.parentOBJ.tripID,
		}
		let check = await TripServices.checkAllDocumentScanned(inputpayload);
		if(check.data.code != 200){
		  this.$alert(check.data.message, "", "error");
		  this.Loader = false
		  return false
		}
		this.ODOErr = ''
		let input = {
		  tripid: this.parentOBJ.tripID,
		  sruserid : this.startTripObj.srUserId,
		  hubid: this.startTripObj.hubid,
		  openkm: Number(this.vehicleODOReading),
		  tripstate: 'start',
		  vehicleno: this.startTripObj.vehicleNumber,
		  vehicletype: this.startTripObj.vehicletype,
		  latitude: 0.0,
		  logitude:0.0,
		  speedmeterurl: 'abcd.gif',
		  tmstripid : this.startTripObj.tmstripid,
		  operationType:"cargo",
		  lastmodifiedby:this.userName,
		}
		if(this.startTripObj.vehicletype == 'vehicle'){
		  input.vehiclevendorid = this.startTripObj.vehiclevendorid
		}
		if((this.firstmileAWBItem.length > 0) || (this.firstmileAWBItem.length == 0 && this.LastmileAWBItem.length == 0)) {
		  let dthinput ={
			tmstripid: this.startTripObj.tmstripid,
			vehiclecapacity: this.startTripObj.vehiclecapacity? this.startTripObj.vehiclecapacity : "",
			tripid: this.parentOBJ.tripID? this.parentOBJ.tripID : "",
		  }
		  input.triptag = 0;
		  let dthresponse = await TripServices.CheckDTHEligiblity(dthinput);
      this.Loader = false;
		  if(dthresponse.data.code == 200){
			if(dthresponse.data.data.dtheligibility == 1) {
			  input.triptag = 2;
			  let destinationhubdetails= dthresponse.data.data.motherhub
			  await this.$fire({
				text: "This trip qualifies for Direct to Hub. Do you want to send shipment directly to hub?",
				type: 'question',
				showCancelButton: true,
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
			  }).then(async (result) => {
				if(result.value == true) {
				  await this.$fire({
					text: "Are you sure you want to make this trip as Direct to hub?",
					type: 'question',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					cancelButtonText: 'No'
				  }).then((result) => {
					if(result.value == true) {
					  this.isdth = 1;
					  this.destinationhubname = destinationhubdetails.destinationhubname
					  input.triptag = 1;
					} else {
					  input.triptag = 2;
					}
				  }).catch((err)=>{
				   console.log(err)
				  });
				} else {
				  input.triptag = 2;
				}
			  }).catch((err)=>{
			   console.log(err)
			  });
			}
		  }
		}
    this.Loader = true;
		let result = await TripServices.startTrip(input);
    this.Loader = false;
		if(result.data.code == 200){
		  this.tripStatus = 'start';
		  if(result.data.data.rtoerr){
			this.$alert(result.data.data.rtoerr.join(", "),"Below awbs are removed from trip because they are marked as RTO and Trip Started Successfully","warning");
		  } else if(this.firstmileAWBItem.length >= 0 && this.LastmileAWBItem.length == 0)
		  {
			this.$alert("Trip Started Successfully", "", "success");
		  }
		  else
		  {
			this.showDepartTrip = true;
		  }
		  this.getTraceIP(input)
		} else{
		  this.$alert(result.data.message, "", "error");
		}
	   // this.showDepartTrip = true;
  
		this.Loader = false
	  } catch (error) {
		this.Loader = false
		console.log("Error --",error)
	  }	
    },

    closeDepartTrip(){
      this.showDepartTrip = false;
    },
    getCustomTableEvent(){

    },
    CloseTrip(){
      this.closeTrip =true;
    },
    callParent() {
      this.closeTrip = false;
    },

    async MarkShortConfirmation(data){
      this.$confirm("This AWB document will be marked short. Please confirm.",`AWB: ${data.awb}`,"question").then(async () => {
        let input = {
          tripid: this.parentOBJ.tripID,
          type: this.defaultTab,
          awb: data.awb
        }
        let result = await TripServices.markAWBShort(input)
        if(result.data.code == 200){
          this.$alert(result.data.message, "", "success");
        } else{
          this.$alert(result.data.message, "", "error");
        }
        this.getTripAWB()
      }).catch((err)=>{
      console.log(err)
      });
    },

    async scanAWB() {
      if(this.Scandocument.length >= this.AWBLengthLimit){
        let input = {
          tripid: this.parentOBJ.tripID,
          type: this.defaultTab,
          awb: this.Scandocument,
          scanstage: 'StartScan'
        }
        let result = await TripServices.scanAWB(input)
        if(result.data.code == 200){
          this.$alertify.success(result.data.message);
          if(this.scannedAWBArr && this.scannedAWBArr.indexOf(this.Scandocument) == -1){
            this.scannedAWBArr.push(this.Scandocument)
          }
          // this.Scandocument = ''
          this.getTripAWB()
        } else {
            this.$alertify.error(result.data.message);
        }
      }
    },

    async scanMPS() {
      if(this.ScanAWB.length >= this.MPSLengthLimit){
        let input = {
          tripid: this.parentOBJ.tripID,
          type: this.defaultTab,
          scanstage: 'StartScan',
          lastmodifiedby:this.userName
        }
        if(this.shipmentType == 1){
          input.awb = this.ScanAWB
        }else if(this.shipmentType == 2){
          input.mps = this.ScanAWB
          input.awb = ''
        }else{
          return false
        }
        let result = await TripServices.scanMPS(input)
        if(result.data.code == 200){
          this.$alertify.success(result.data.message);
          this.getTripAWB()
        } else{
          if(!(result.data.message == "MPS already loaded. Please scan another MPS.")){
            this.$alertify.error(result.data.message);
          }
        }
      }
    },

    checkODOKm(){
      if(this.vehicleODOReading<0){
        this.vehicleODOReading = ''
      }else if(Number(this.vehicleODOReading)>9999999999){
        this.ODOErr = 'Maximum 10 digits allowed for ODO reading'
      }
      else {
        this.ODOErr="";
        this.vehicleODOReading = this.vehicleODOReading.replace(/[^0-9]/g, '');
        }
    },
    getTraceIP(tripid) {
      let data =
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/TripManagement',
          "meta" : {
            "event" : `Start Trip`,
            "data" : tripid
          }
      }
      let result = iptracker.getTraceIP(data);
    },
    displayMPS(data){
      this.modalData=data;
        this.showMPS = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/startTrip/startTrip.component.js